import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const LoadingError = ({component}) => {
    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
        }}>
            <Typography variant="h4" sx={{ textAlign: 'center'}}>
                {`Failed to load ${component}. Please refresh the page.`}
            </Typography>
        </Box>
    );
}

export default LoadingError;